import { z } from "zod";
import { RESOURCE_LABEL_MAX_LENGTH } from "@/other/constants/OtherKeys";

export const resourceSchema = z.object({
  name: z
    .string()
    .min(1, "Resource ID is required")
    .max(RESOURCE_LABEL_MAX_LENGTH, `Resource ID must be ${RESOURCE_LABEL_MAX_LENGTH} characters or less`),
  description: z
    .string()
    .max(5000, "Description must be less than 5000 characters")
    .optional()
    .or(z.literal("")),
  location: z
    .string()
    .max(500, "Location must be less than 500 characters")
    .optional()
    .or(z.literal(""))
});

export type ResourceFormData = z.infer<typeof resourceSchema>;